import React from 'react';
import { Heading } from "../../components/typography/Heading";
export var getPricePerPeriodMarkup = function getPricePerPeriodMarkup(pricePerPeriod, pricePerPeriodPrefix, periodText) {
  var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'medium';
  return React.createElement("span", null, "".concat(pricePerPeriodPrefix), " ", React.createElement(Heading, {
    size: size
  }, pricePerPeriod), "".concat(periodText));
};